import {
  ArticlePartType,
  ArticleProposalDetail,
  ArticleProposalListItem,
  ArticleRecord,
  ArticleStatus,
  ArticleTone,
  ArticleVersionDetail
} from '@/common/model/media/article'

// 記事管理（article_proposals / articles / article_parts）
export const ArticlesApiPath = {
  LIST_ARTICLES: '/api/sites/{site_id}/articles', // GET List Articles
  CREATE_ARTICLE: '/api/sites/{site_id}/articles', // POST Create Article
  GET_ARTICLE_DETAIL: '/api/sites/{site_id}/articles/{article_proposal_id}', // GET Get Article Detail
  GET_ARTICLE_VERSION_DETAIL:
    '/api/sites/{site_id}/articles/{article_proposal_id}/versions/{article_id}', // GET Get Article Version Detail
  CREATE_ARTICLE_VERSION: '/api/sites/{site_id}/articles/versions', // POST Create Article New Version
  UPDATE_ARTICLE: '/api/sites/{site_id}/articles/{article_id}', // PUT Update Article
  DUPLICATE_ARTICLE: '/api/sites/{site_id}/articles/{article_proposal_id}/duplicate', // POST Duplicate Article
  DELETE_ARTICLE: '/api/sites/{site_id}/articles/{article_proposal_id}', // DELETE Delete Article
  UPLOAD_ARTICLE_IMAGE: '/api/sites/{site_id}/articles/upload-image', // POST Upload Article Image
  BATCH_DIAGNOSE_ARTICLES: '/api/sites/{site_id}/articles/batch-diagnose' // GET Batch Diagnose Articles
}

export type ArticlesApiPath = (typeof ArticlesApiPath)[keyof typeof ArticlesApiPath]

export interface ListArticlesVars {
  site_id: number
  creation_source?: string | null
  status?: string | null
  site_operator_id?: number | null
  page?: number
  per_page?: number
}

export interface ListArticlesResponse {
  total: number
  items: ArticleProposalListItem[]
}

export interface GetArticleDetailVars {
  site_id: number
  article_proposal_id: number
}

export type GetArticleDetailResponse = ArticleProposalDetail

export interface GetArticleVersionDetailVars {
  site_id: number
  article_proposal_id: number
  article_id: number
}

export type GetArticleVersionDetailResponse = ArticleVersionDetail

export interface ArticlePartInput {
  part_type: ArticlePartType
  content_html?: string | null
  image_path?: string | null
  page_title?: string | null
}

export interface CreateArticleVars {
  site_id: number
  title?: string | null
  slug?: string | null
  keyword?: string | null
  meta_description?: string | null
  heading_outline?: string | null
  tone?: ArticleTone | null
  persona?: string | null
  target_char_count?: number | null
  ai_used?: boolean
  source_media_action_id?: number | null
  parts?: ArticlePartInput[]
}

export type CreateArticleResponse = ArticleRecord

export interface CreateArticleVersionVars {
  site_id: number
  article_proposal_id: number
  title?: string | null
  slug?: string | null
  keyword?: string | null
  meta_description?: string | null
  heading_outline?: string | null
  tone?: ArticleTone | null
  persona?: string | null
  target_char_count?: number | null
  source_diagnosis_id?: number | null
  ai_used?: boolean
  source_media_action_id?: number | null
  parts?: ArticlePartInput[]
}

export type CreateArticleVersionResponse = ArticleRecord

export interface UpdateArticleVars {
  site_id: number
  article_id: number
  title?: string | null
  slug?: string | null
  keyword?: string | null
  meta_description?: string | null
  heading_outline?: string | null
  tone?: ArticleTone | null
  persona?: string | null
  target_char_count?: number | null
  status?: ArticleStatus | null
  ai_used?: boolean
  parts?: ArticlePartInput[] | null
}

export type UpdateArticleResponse = ArticleRecord

export interface DuplicateArticleVars {
  site_id: number
  article_proposal_id: number
}

export type DuplicateArticleResponse = ArticleRecord

export interface DeleteArticleVars {
  site_id: number
  article_proposal_id: number
}

export interface DeleteArticleResponse {
  deleted: boolean
}

export interface UploadArticleImageVars {
  site_id: number
  file: File
}

export interface UploadArticleImageResponse {
  image_path: string
}

// -----------------------------------------------
// 記事診断結果一覧（/articles/batch-diagnose。ルールベース簡易診断。AIは使用しない）
// -----------------------------------------------

export interface BatchDiagnoseArticlesVars {
  site_id: number
}

export interface ArticleBatchDiagnoseItem {
  article_proposal_id: number
  title: string
  seo_score: number
  impact: number
  effort: number
  priority: 'high' | 'medium' | 'low' | string
}

export interface BatchDiagnoseArticlesResponse {
  items: ArticleBatchDiagnoseItem[]
  total: number
}
